import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppContext } from "./app-context.service";
import { LoginService } from "./login.service";
import { PosDataService } from "./pos.data.service";

@Injectable({
  providedIn: "root",
})
export class LogoutService {
  public logOutTimer: ReturnType<typeof setTimeout>;
  public logOutTimerNotifier: ReturnType<typeof setTimeout>;
  public timerCheck: ReturnType<typeof setInterval>;
  public action: boolean = false;

  constructor(
    private loginService: LoginService,
    private router: Router,
    public appContext: AppContext,
    private posDataService: PosDataService,
    private toastr: ToastrService
  ) {}

  public unsetLogoutTimer() {
    clearTimeout(this.logOutTimer);
    clearTimeout(this.logOutTimerNotifier);
    clearInterval(this.timerCheck);
  }
  public refreshLogoutTimer() {
    this.action = true;
  }
  public setLogoutTimer() {
    if (this.appContext.posApiConfig.logOutAfterMinutes) {
      if (this.appContext.posApiConfig.logOutAfterMinutes > 0) {
        this.unsetLogoutTimer();

        this.logOutTimer = setTimeout(
          () => this.logout(),
          this.appContext.posApiConfig.logOutAfterMinutes
        );
        if (this.appContext.posApiConfig.logOutAfterMinutes - 300000 > 0) {
          this.logOutTimerNotifier = setTimeout(
            () =>
              this.toastr.error(
                "Z důvodu neaktivity budete za 5 minut odhlášeni"
              ),
            this.appContext.posApiConfig.logOutAfterMinutes - 300000
          );
        }
        this.timerCheck = setInterval(() => this.checkTimer(), 5000);
      }
    }
  }
  checkTimer() {
    if (this.action) {
      this.setLogoutTimer();
      this.action = false;
    }
  }
  public async logout() {
    this.unsetLogoutTimer();
    await this.loginService.logout();
    this.loginService.loggedIn = false;
    await this.router.navigateByUrl("/initialization");
  }
}
